import router from './router'
import store from './store'
import  {routes} from  './router/index'
import {getToken} from './utils/auth'
import {getUserInfo} from "./views/Home/homeApiMethod"; // 验权

const whiteList = ['/login', '/middle'] // 不重定向白名单
var clearSlct= "getSelection" in window ? function(){
    window.getSelection().removeAllRanges();
} : function(){
    document.selection.empty();
};
router.beforeEach((to, from, next) => {
    clearSlct();

    if (getToken()) {
        getUserInfo().then(res => {
            store.dispatch('setUserInfo', res).then(() => {
            });
            if (to.path === '/login' || to.path === '/middle') {
                next({path: '/'})
            } else {
                next()
            }
        })
    } else {
        store.commit('setDefRouters', [])
        if (whiteList.indexOf(to.path) !== -1) {
            next()
        } else {
            next('/login')
        }
    }
    // next()
    // if (getToken()) {
    //     if (to.path === '/login') {
    //
    //     } else {
    //
    //         if (routes && routes.length > 0) {
    //             next()
    //         } else {
    //             next({...to, replace: true})
    //         }
    //     }
    // } else {
    //     if (whiteList.indexOf(to.path) !== -1) {
    //         next()
    //     } else {
    //         next('/login')
    //     }
    // }
})
